import { Button } from "@/components/ui/button";
import { Pen, PenLine, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { DeleteConfirmDialog } from "./all-staff-dialog";
import FormInputField from "../../lib/from-input-field";
import { Form } from "@/components/ui/form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Separator } from "@/components/ui/separator";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { addRole, removeRole, editRole } from "@/redux/slice/all-role-slice";
import { useDispatch } from "react-redux";
import useAuth from "@/hooks/useAuth";
import hasPermission from "@/hooks/hasPermission";
import { restaurant_id as fallbackRestaurantId } from "@/api/lib/url";

const roleSchema = z.object({
  name: z.string().min(1, "Role name is required"),
  description: z.string().optional(),
  role_type: z.string().min(1).max(100).default("restaurant"),
  // permissions: z
  //   .array(z.number())
  //   .min(1, "At least one permission is required"),
});
export function AddNewRoleDialog({ addRoleModal, setAddRoleModal }) {
  const form = useForm({
    resolver: zodResolver(roleSchema),
    defaultValues: {
      name: "",
      description: "",
      role_type: "restaurant",
      restaurant_id: 1,
      client_id: 1,
      // permissions: [1, 2, 3, 4, 5],
    },
  });

  const dispatch = useDispatch();
  const { permissions } = useSelector((state) => state.allPermissions);
  const { roles, loading } = useSelector((state) => state?.allRoles);
  const { user } = useAuth();

  const createRole = async (data) => {
    const restaurantId =
      user?.restaurant_id ||
      localStorage.getItem("restaurant_id") ||
      fallbackRestaurantId ||
      1;
    const clientId = user?.client_id || 1;

    const payload = {
      ...data,
      restaurant_id: restaurantId,
      client_id: clientId,
    };
    try {
      const res = await dispatch(addRole(payload));
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Role added successfully!");
        setAddRoleModal(false);
      } else {
        toast.error(res?.payload);
      }
    } catch (error) {
      toast.error("Somthing went wrong!");
    }
  };

  return (
    <Dialog open={addRoleModal} onOpenChange={() => setAddRoleModal(false)}>
      <DialogContent className="sm:max-w-[400px]">
        <div className="py-5 flex flex-col">
          <DialogTitle className="text-lg absolute top-4 text-cgreen font-medium">
            Add New Role
          </DialogTitle>
          <Separator className="mt-4" />
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(createRole)}
              className="flex flex-col gap-5 mt-6"
            >
              <FormInputField
                name="name"
                style="bg-cblack3"
                placeholder={"Enter new role name"}
                form={form}
                type="text"
                label={"Role Name"}
                required={true}
              />
              {/* <FormInputField
                name="role_type"
                style="bg-cblack3"
                placeholder={"Select Role Type"}
                form={form}
                selectOption={[
                  {
                    label: "System",
                    value: "system",
                  },
                  {
                    label: "Client",
                    value: "client",
                  },

                  {
                    label: "Restaurant",
                    value: "restaurant",
                  },
                ]}
                type="select"
                label={"Role Type"}
              /> */}
              <FormInputField
                name="description"
                style="bg-cblack3"
                placeholder={"Description"}
                form={form}
                type="textarea"
                label={"Description"}
              />

              <Button
                isLoading={loading}
                className="bg-cyellow w-full mt-5 text-cblack"
              >
                Confirm
              </Button>
            </form>
          </Form>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function RoleListDialog({
  roles = [],
  loading = false,
  roleListDialog,
  setRoleListModal,
}) {
  const [deleteModel, setDeleteModel] = useState(false);
  const [editModel, setEditModel] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const onConfirmDelete = async (selectedRole) => {
    const res = await dispatch(removeRole(selectedRole?.id));
    if (res.meta.requestStatus === "fulfilled") {
      toast.success("Role Delete successfully!");
    } else {
      toast.error("Failed to delete role.");
    }
  };

  if (loading) return <div>Loading...</div>;
  return (
    <Dialog open={roleListDialog} onOpenChange={() => setRoleListModal(false)}>
      <DialogContent className="sm:max-w-[600px]">
        <div className="pt-5 flex flex-col">
          <DialogTitle className="text-lg absolute top-4 text-cgreen font-medium">
            Role List
          </DialogTitle>
          <Separator className="mt-4" />
          <div className="flex flex-col gap-2 mt-4">
            {/* <div className='py-2'>
              <h2 className='text-cwhite2'>Super Admin</h2>
            </div>
            <Separator /> */}

            {roles?.length > 0 ? (
              roles.map((role) => (
                <div
                  className="py-2 flex justify-between items-center"
                  key={role.id}
                >
                  <h2 className="text-cwhite2">{role?.name}</h2>
                  <div className="gap-2.5 px-4 flex justify-center items-center">
                    {hasPermission("back_office.staff_management.role_update") && (
                      <PenLine
                        onClick={() => {
                          setEditModel(true);
                          setSelectedRole(role);
                        }}
                        className="text-cyellow cursor-pointer"
                        size={16}
                      />
                    )}
                    {hasPermission("back_office.staff_management.role_delete") && (
                      <Trash2
                        onClick={() => {
                          setDeleteModel(true);
                          setSelectedRole(role);
                        }}
                        size={16}
                        className="text-cred cursor-pointer"
                      />
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div>No roles found</div>
            )}
          </div>
        </div>
      </DialogContent>
      {/* dialog */}
      <DeleteConfirmDialog
        onConfirm={() => onConfirmDelete(selectedRole)}
        title="Delete Role"
        description="Are you sure you want to delete this role? This action cannot be undone."
        confirmText="Delete"
        isOpen={deleteModel}
        onClose={() => setDeleteModel(false)}
      />
      <EditRoleDialog
        editRoleModel={editModel}
        setEditRoleModel={setEditModel}
        selectedRole={selectedRole}
      />
    </Dialog>
  );
}

const editRoleSchema = z.object({
  name: z.string().min(1, "Role name is required"),
  description: z.string().optional(),
  role_type: z.string().min(1).max(100).default("restaurant"),
  // permissions: z
  //   .array(z.number())
  //   .min(1, "At least one permission is required"),
});
export function EditRoleDialog({
  selectedRole,
  editRoleModel,
  setEditRoleModel,
}) {
  const form = useForm({
    resolver: zodResolver(editRoleSchema),
    defaultValues: {
      name: "",
      description: "",
      role_type: "restaurant",
      restaurant_id: 1,
      client_id: 1,
      // permissions: [1, 2, 3, 4, 5],
    },
  });

  useEffect(() => {
    if (selectedRole) {
      form.reset({
        ...selectedRole,
        name: selectedRole.name,
        description: selectedRole.description || "",
        role_type: selectedRole.role_type || "restaurant",
      });
    }
  }, [selectedRole]);

  const dispatch = useDispatch();
  const { permissions } = useSelector((state) => state.allPermissions);
  const { roles, loading } = useSelector((state) => state?.allRoles);
  const { user } = useAuth();

  const updateRole = async (data) => {
    const restaurantId =
      user?.restaurant_id ||
      localStorage.getItem("restaurant_id") ||
      fallbackRestaurantId ||
      1;
    const clientId = user?.client_id || 1;

    const payload = {
      ...data,
      restaurant_id: restaurantId,
      client_id: clientId,
    };
    try {
      const res = await dispatch(
        editRole({ id: selectedRole?.id, data: payload })
      );

      if (editRole.fulfilled.match(res)) {
        toast.success("Role updated successfully!");
        setEditRoleModel(false);
      } else if (editRole.rejected.match(res)) {
        toast.error(res?.payload || "Failed to update role!");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    }
  };

  return (
    <Dialog open={editRoleModel} onOpenChange={() => setEditRoleModel(false)}>
      <DialogContent className="sm:max-w-[400px]">
        <div className="py-5 flex flex-col">
          <DialogTitle className="text-lg absolute top-4 text-cgreen font-medium">
            Edit Role
          </DialogTitle>
          <Separator className="mt-4" />
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(updateRole)}
              className="flex flex-col gap-5 mt-6"
            >
              <FormInputField
                name="name"
                style="bg-cblack3"
                placeholder={"Enter new role name"}
                form={form}
                type="text"
                label={"Role Name"}
                required={true}
              />
              {/* <FormInputField
                name="role_type"
                style="bg-cblack3"
                placeholder={"Select Role Type"}
                form={form}
                selectOption={[
                  {
                    label: "System",
                    value: "system",
                  },
                  {
                    label: "Client",
                    value: "client",
                  },

                  {
                    label: "Restaurant",
                    value: "restaurant",
                  },
                ]}
                type="select"
                label={"Role Type"}
              /> */}
              <FormInputField
                name="description"
                style="bg-cblack3"
                placeholder={"Description"}
                form={form}
                type="textarea"
                label={"Description"}
              />

              <Button
                isLoading={loading}
                className="bg-cyellow w-full mt-5 text-cblack"
              >
                Confirm
              </Button>
            </form>
          </Form>
        </div>
      </DialogContent>
    </Dialog>
  );
}
